document.addEventListener("DOMContentLoaded", function() {
    const eventCardsContainer = document.getElementById("humanitix-event-cards");
    const sectionContainer = eventCardsContainer.closest('.container--large'); // Assuming the section container has this class
    const hostIdentifier = eventCardsContainer.dataset.hostIdentifier;

    // Hide the section by default
    sectionContainer.classList.add("hidden");

    // Only fetch events if a host identifier is provided
    if (hostIdentifier) {
        fetchEvents(hostIdentifier).then(events => {
            if (!events || events.length === 0) {
                console.warn('No events found or there was an issue fetching events.');
                return;
            }

            // Show the section since there are events
            sectionContainer.classList.remove("hidden");
            const layoutClass = eventCardsContainer.dataset.layout;
            const aspectRatio = parseFloat(eventCardsContainer.dataset.imageAspectRatio) || 1.3333; // Default to 4:3 aspect ratio
            const gridContainer = document.createElement('div');
            gridContainer.className = `grid grid--layout ${layoutClass} grid--align-items-stretch`;

            events.forEach(event => {
                // Create the card container
                const card = document.createElement('div');
                card.className = 'card card--animation';

                // Create the image container
                const imageContainer = document.createElement('div');
                imageContainer.className = 'card__image';
                imageContainer.style.paddingTop = `${100 / aspectRatio}%`;

                // Create the figure element to wrap the image
                const figureElement = document.createElement('figure');
                figureElement.className = 'lazy-image lazy-image--background lazy-image--animation';
                figureElement.style.paddingTop = `${100 / aspectRatio}%`;
                figureElement.dataset.ratio = aspectRatio.toString();
                figureElement.dataset.crop = 'false';

                // Create the image element
                const imageUrl = event.featureImage?.url || event.bannerImage?.url || event.socialImage?.url || '';
                const image = document.createElement('img');
                image.src = imageUrl;
                image.alt = event.name;
                image.className = 'img';
                image.style.width = '100%';
                image.style.height = '100%';
                image.style.objectFit = 'cover';
                image.dataset.ratio = aspectRatio.toString();
                image.loading = 'lazy';

                // Set srcset for responsive image loading
                image.srcset = `
                    ${imageUrl}?crop=center&height=180&width=240 240w,
                    ${imageUrl}?crop=center&height=270&width=360 360w,
                    ${imageUrl}?crop=center&height=315&width=420 420w,
                    ${imageUrl}?crop=center&height=360&width=480 480w,
                    ${imageUrl}?crop=center&height=480&width=640 640w,
                    ${imageUrl}?crop=center&height=630&width=840 840w,
                    ${imageUrl}?crop=center&height=810&width=1080 1080w,
                    ${imageUrl}?crop=center&height=960&width=1280 1280w,
                    ${imageUrl}?crop=center&height=1155&width=1540 1540w,
                    ${imageUrl}?crop=center&height=1395&width=1860 1860w,
                    ${imageUrl}?crop=center&height=1575&width=2100 2100w
                `;

                image.sizes = "(max-width: 767px) calc(100vw - 20px), (max-width: 1360px) 33vw, 453px";

                // Add event listener to handle the lazyload effect
                image.onload = function() {
                    this.parentNode.classList.add('lazyloaded');
                    imageReveal.observe(this.parentNode);
                };

                // Append the image to the figure
                figureElement.appendChild(image);

                // Append the figure to the image container
                imageContainer.appendChild(figureElement);

                // Append the image container to the card
                card.appendChild(imageContainer);

                // Create and append the text and button elements
                const cardText = document.createElement('div');
                cardText.className = `card__text gutter--large spacing--custom text-align--center remove-empty-space`;
                cardText.style.setProperty('--spacing', '12px');

                const title = document.createElement('h3');
                title.className = 'text-font--heading heading-size--small';
                const titleSpan = document.createElement('span');
                titleSpan.style.fontSize = '100%';
                titleSpan.innerText = event.name;
                title.appendChild(titleSpan);
                cardText.appendChild(title);

                const dateDiv = document.createElement('div');
                const dateSpan = document.createElement('span');
                dateSpan.className = 'text-color--opacity text-size--regular';
                dateSpan.innerText = `${new Date(event.startDate).toLocaleString('en-AU', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: 'numeric' })}`;
                dateDiv.appendChild(dateSpan);
                cardText.appendChild(dateDiv);

                // Button
                if (event.slug) {
                    const buttonContainer = document.createElement('div');
                    const button = document.createElement('a');
                    button.href = `https://events.humanitix.com/${event.slug}`;
                    button.className = `button button--outline button--icon`;
                    button.target = "_blank"; // Open in a new tab

                    const buttonIcon = document.createElement('span');
                    buttonIcon.className = 'button__icon';
                    buttonIcon.setAttribute('role', 'img');
                    buttonIcon.setAttribute('aria-hidden', 'true');
                    buttonIcon.innerHTML = '<svg width="21" height="9" viewBox="0 0 21 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.354 4.854a.5.5 0 0 0 0-.708L17.172.964a.5.5 0 1 0-.707.708L19.293 4.5l-2.828 2.828a.5.5 0 1 0 .707.708l3.182-3.182ZM0 5h20V4H0v1Z" fill="#000"></path></svg>';

                    const buttonText = document.createElement('span');
                    buttonText.className = 'button__text text-weight-- text-size--';
                    buttonText.innerText = 'Learn More';

                    button.appendChild(buttonIcon);
                    button.appendChild(buttonText);
                    buttonContainer.appendChild(button);
                    cardText.appendChild(buttonContainer);
                }

                card.appendChild(cardText);

                // Add the card to the grid
                gridContainer.appendChild(card);
            });

            // Append the grid to the event cards container
            eventCardsContainer.appendChild(gridContainer);
        }).catch(error => {
            console.error('Error fetching events:', error);
            sectionContainer.classList.add("hidden"); // Hide the entire section on error
        });
    } else {
        console.warn('No host identifier provided.');
        sectionContainer.classList.add("hidden"); // Hide the entire section if no host identifier
    }

    function fetchEvents(hostIdentifier) {
        return fetch(`https://36u4avl36uqwlk6kqqzcro7y5u0xsagg.lambda-url.ap-southeast-2.on.aws/?h=${hostIdentifier}`)
            .then(response => response.json())
            .then(data => data.events || [])
            .catch(error => {
                console.error('Error fetching events:', error);
                return [];
            });
    }
});
